// eslint-disable-next-line spire/export-chain
const cacheKey = "filter";

const setInLocalStorage = (filterIds: string[], type: string) => {
    window.localStorage.setItem(type + cacheKey, JSON.stringify(filterIds));
};

export function getFilterIds(type: string): string[] {
    return JSON.parse(window.localStorage.getItem(type + cacheKey) || "[]") as string[];
}

export function addDocumentsFilter(filterId: string, type: string): boolean {
    const filterIds = getFilterIds(type);
    if (!filterIds.includes(filterId)) {
        filterIds.push(filterId);
        setInLocalStorage(filterIds, type);
        return true;
    }
    return false;
}

export function removeDocumentsFilter(filterId: string, type: string): boolean {
    let filterIds = getFilterIds(type);
    if (filterIds.includes(filterId)) {
        filterIds = filterIds.filter(a => a !== filterId);
        setInLocalStorage(filterIds, type);
        return true;
    }
    return false;
}

export function removeAllDocumentsFilters(): void {
    setInLocalStorage([], "doctype");
    setInLocalStorage([], "doclang");
}
